module.exports = "/images/bluetooth.jpg?ac67f4d40930fd7a59fc85b7d032fbb6";